import { getQueryUrl } from 'utils';
import { apiVersion } from '../apis.const';
import { transformResponse } from '../apis.util';
import { baseApi } from '../base.api';

/**
 * Create APIs
 */
export const metricsApi = baseApi.injectEndpoints({
  overrideExisting: false,

  endpoints: (build) => ({
    fetchScansCount: build.query<FetchScansCountRes, FetchScansCountReq>({
      query: ({ orgSlug, buildingId, zoneId, start, end }) => ({
        url: getQueryUrl({
          url: `${orgSlug}/${apiVersion}/metrics/scans/count`,
          queryObj: { buildingId, zoneId, start, end },
        }),
      }),
      transformResponse,
      providesTags: ['ScansCount'],
    }),

    fetchSubscribersCount: build.query<FetchSubscribersCountRes, FetchSubscribersCountReq>({
      query: ({ orgSlug, buildingId, zoneId }) => ({
        url: getQueryUrl({
          url: `${orgSlug}/${apiVersion}/metrics/subscriber/count`,
          queryObj: { buildingId, zoneId },
        }),
      }),
      transformResponse,
      providesTags: ['SubscribersCount'],
    }),

    fetchScheduleProgress: build.query<FetchScheduleProgressRes, FetchScheduleProgressReq>({
      query: ({ orgSlug, buildingId, zoneId, date }) => ({
        url: getQueryUrl({
          url: `${orgSlug}/${apiVersion}/metrics/schedule/progress`,
          queryObj: { buildingId, zoneId, date },
        }),
      }),
      transformResponse,
      providesTags: ['ScheduleProgress'],
    }),
  }),
});

/**
 * Hooks
 */
export const { useFetchScansCountQuery, useFetchSubscribersCountQuery, useFetchScheduleProgressQuery } = metricsApi;

/**
 * Types
 */
type OrgSlug = {
  orgSlug: string;
};

type FetchScansCountRes = any;
type FetchScansCountReq = OrgSlug & {
  buildingId?: number;
  zoneId?: number;
  start: string;
  end: string;
};
type FetchSubscribersCountRes = any;
type FetchSubscribersCountReq = OrgSlug & {
  buildingId?: number;
  zoneId?: number;
};
type FetchScheduleProgressRes = any;
type FetchScheduleProgressReq = OrgSlug & {
  buildingId?: number;
  zoneId?: number;
  date?: string;
};
